@import '~style-sheet-helpers/core.less';

.tab-content-old {
  height: 100%;
  width: 100%;
  max-height: 100%;
  max-width: 100%;
  overflow: auto;
}
